var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body-block" },
    [
      _c("DisclaimerBar", {
        attrs: {
          content: _vm.disclaimerContent,
          isAdmin: _vm.isAdmin,
          isLoading: _vm.isLoading,
        },
        on: { save: _vm.handleSaveDisclaimer },
      }),
      _c(
        "div",
        { staticClass: "board-container" },
        _vm._l(_vm.columns, function (column) {
          return _c("board-column", {
            key: column.id,
            attrs: {
              column: column,
              "action-column": _vm.getActionColumn(column),
              "member-options": _vm.memberOptions,
            },
            on: {
              "add-card": _vm.handleAddCard,
              "card-click": _vm.openCardDetail,
              "card-toggle-check": _vm.toggleCheck,
              "card-archive": _vm.archiveCard,
            },
          })
        }),
        1
      ),
      _c("card-detail-dialog", {
        attrs: {
          isSaving: _vm.isSaving,
          visible: _vm.detailDialogVisible,
          card: _vm.activeCard,
          "column-id": _vm.activeCardColumnId,
          columns: _vm.columns,
          "member-options": _vm.memberOptions,
        },
        on: {
          "update:isSaving": function ($event) {
            _vm.isSaving = $event
          },
          "update:is-saving": function ($event) {
            _vm.isSaving = $event
          },
          "update:visible": function ($event) {
            _vm.detailDialogVisible = $event
          },
          "column-switch": _vm.handleColumnSwitch,
          "toggle-check": _vm.toggleCheck,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }